import { useMemo } from "react";
import { UseGetRfiListForFilters } from "./queries";
import { withoutLocalTemplateCategories } from "../utils/libraryServiceCategories";

/** The service category catalog as the library filters offer it: without local categories. */
export const useLibraryRfiListForFilters = () => {
  const query = UseGetRfiListForFilters();
  const data = useMemo(() => withoutLocalTemplateCategories(query.data), [query.data]);
  return { ...query, data };
};
